import PeopleDetails from './PeopleDetails'
import enhance from './PeopleDetails.enhancer'

export default enhance(PeopleDetails)



// WEBPACK FOOTER //
// ./src/containers/people/PeopleDetails/index.js